export const SPORTER_STATE = 0;
export const TEST_STATE = 1;
